(function () {
  if (window.__mistikaAjaxCartFixApplied) return;

  window.__mistikaAjaxCartFixApplied = true;
  window.__mistikaAjaxCartFixLoaded = true;

  const root = window.Shopify?.routes?.root || '/';

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      const button = form.querySelector('[type="submit"], [name="add"]');

      if (
        button &&
        (button.disabled || button.getAttribute('aria-disabled') === 'true')
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const formData = new FormData(form);

      if (!formData.get('id')) {
        alert('Selecciona una opción disponible antes de agregar al carrito.');
        return;
      }

      if (!formData.get('quantity')) {
        formData.set('quantity', '1');
      }

      try {
        setButtonLoading(button, true);

        const addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        });

        const addData = await addResponse.json().catch(function () {
          return {};
        });

        console.log('[Mistika Cart] add.js:', addResponse.status, addData);

        if (!addResponse.ok || addData.status) {
          throw new Error(
            addData.description ||
              addData.message ||
              'No fue posible agregar este producto al carrito.'
          );
        }

        const cart = await fetch(root + 'cart.js', {
          headers: {
            Accept: 'application/json'
          }
        }).then(function (response) {
          return response.json();
        });

        console.log('[Mistika Cart] Carrito actualizado:', cart);

        removeMistikaBubbles();
        await refreshHeaderSection();
        updateNativeCartCounters(cart.item_count);
        showMistikaMiniCart(cart);
        dispatchCartEvents(cart, addData);
      } catch (error) {
        console.error('[Mistika Cart] Error:', error);
        alert(error.message);
      } finally {
        setButtonLoading(button, false);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    removeMistikaBubbles();
  });

  function setButtonLoading(button, loading) {
    if (!button) return;

    if (loading) {
      button.dataset.originalText = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = 'Agregando...';
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');

      if (button.dataset.originalText) {
        button.innerHTML = button.dataset.originalText;
      }
    }
  }

  function removeMistikaBubbles() {
    document
      .querySelectorAll('.mistika-header-cart-bubble, .mistika-cart-bubble')
      .forEach(function (bubble) {
        bubble.remove();
      });
  }

  async function refreshHeaderSection() {
    try {
      const response = await fetch(root + '?sections=header', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const sections = await response.json();

      if (!sections || !sections.header) {
        console.warn('[Mistika Cart] Shopify no devolvió la sección header.');
        return;
      }

      const parser = new DOMParser();
      const newDocument = parser.parseFromString(sections.header, 'text/html');

      const newHeader =
        newDocument.querySelector('#shopify-section-header') ||
        newDocument.querySelector('header') ||
        newDocument.querySelector('.header-wrapper') ||
        newDocument.querySelector('.header');

      const currentHeader =
        document.querySelector('#shopify-section-header') ||
        document.querySelector('header') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('.header');

      if (newHeader && currentHeader) {
        currentHeader.innerHTML = newHeader.innerHTML;
        console.log('[Mistika Cart] Header renderizado nuevamente.');
      } else {
        console.warn('[Mistika Cart] No se pudo reemplazar el header.');
      }
    } catch (error) {
      console.warn('[Mistika Cart] No se pudo refrescar el header:', error);
    }
  }

  function updateNativeCartCounters(itemCount) {
    const selectors = [
      '[data-cart-count]',
      '[data-header-cart-count]',
      '.cart-count',
      '.cart__count',
      '.cart-count-bubble',
      '.header__cart-count',
      '.site-header__cart-count',
      '.js-cart-count',
      '.cart-link__bubble-num',
      '.cart-item-count',
      '.cart-icon-count',
      '.cart-count-number',
      '.cart-items-count'
    ];

    let updated = false;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (counter) {
        if (counter.closest('#mistika-mini-cart-panel')) return;
        if (counter.classList.contains('mistika-header-cart-bubble')) return;
        if (counter.classList.contains('mistika-cart-bubble')) return;

        counter.textContent = itemCount;
        counter.setAttribute('data-count', itemCount);
        counter.classList.remove('hidden', 'is-empty');
        counter.style.display = itemCount > 0 ? '' : 'none';

        updated = true;
      });
    });

    console.log('[Mistika Cart] Contadores nativos actualizados:', updated, itemCount);
  }

  function showMistikaMiniCart(cart) {
    injectMistikaStyles();

    let panel = document.getElementById('mistika-mini-cart-panel');

    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'mistika-mini-cart-panel';
      document.body.appendChild(panel);
    }

    const subtotal = formatMoney(cart.total_price);

    const itemsHtml = cart.items
      .slice(0, 3)
      .map(function (item) {
        return `
          <div class="mistika-mini-cart-item">
            ${
              item.image
                ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
                : ''
            }
            <div>
              <strong>${escapeHtml(item.product_title)}</strong>
              <span>${escapeHtml(item.variant_title || '')}</span>
              <small>Cantidad: ${item.quantity}</small>
            </div>
          </div>
        `;
      })
      .join('');

    panel.innerHTML = `
      <button class="mistika-mini-cart-close" type="button" aria-label="Cerrar">×</button>
      <h3>Producto agregado al carrito</h3>
      <p>Tienes <strong>${cart.item_count}</strong> artículo${cart.item_count === 1 ? '' : 's'} en tu carrito.</p>

      <div class="mistika-mini-cart-items">
        ${itemsHtml}
      </div>

      <div class="mistika-mini-cart-total">
        <span>Subtotal</span>
        <strong>${subtotal}</strong>
      </div>

      <div class="mistika-mini-cart-actions">
        <a href="/cart">Ver carrito</a>
        <a href="/checkout">Finalizar compra</a>
      </div>
    `;

    panel.classList.add('is-visible');

    panel
      .querySelector('.mistika-mini-cart-close')
      .addEventListener('click', function () {
        panel.classList.remove('is-visible');
      });

    window.clearTimeout(window.__mistikaMiniCartTimer);

    window.__mistikaMiniCartTimer = window.setTimeout(function () {
      panel.classList.remove('is-visible');
    }, 6000);
  }

  function injectMistikaStyles() {
    if (document.getElementById('mistika-cart-styles')) return;

    const style = document.createElement('style');
    style.id = 'mistika-cart-styles';

    style.textContent = `
      .mistika-header-cart-bubble,
      .mistika-cart-bubble {
        display: none !important;
      }

      #mistika-mini-cart-panel {
        position: fixed;
        top: 20px;
        right: 20px;
        width: min(380px, calc(100vw - 40px));
        background: #fff;
        color: #111;
        z-index: 999999;
        padding: 20px;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.18);
        transform: translateY(-20px);
        opacity: 0;
        pointer-events: none;
        transition: all 0.25s ease;
        border: 1px solid rgba(0, 0, 0, 0.08);
      }

      #mistika-mini-cart-panel.is-visible {
        transform: translateY(0);
        opacity: 1;
        pointer-events: auto;
      }

      #mistika-mini-cart-panel h3 {
        margin: 0 28px 8px 0;
        font-size: 18px;
      }

      #mistika-mini-cart-panel p {
        margin: 0 0 14px;
        font-size: 14px;
      }

      .mistika-mini-cart-close {
        position: absolute;
        top: 10px;
        right: 12px;
        border: 0;
        background: transparent;
        font-size: 26px;
        cursor: pointer;
      }

      .mistika-mini-cart-item {
        display: flex;
        gap: 12px;
        padding: 10px 0;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
      }

      .mistika-mini-cart-item img {
        width: 58px;
        height: 72px;
        object-fit: cover;
        background: #f6f6f6;
      }

      .mistika-mini-cart-item strong,
      .mistika-mini-cart-item span,
      .mistika-mini-cart-item small {
        display: block;
        font-size: 13px;
        line-height: 1.35;
      }

      .mistika-mini-cart-item span,
      .mistika-mini-cart-item small {
        opacity: 0.7;
      }

      .mistika-mini-cart-total {
        display: flex;
        justify-content: space-between;
        padding-top: 14px;
        margin-top: 8px;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
      }

      .mistika-mini-cart-actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        margin-top: 16px;
      }

      .mistika-mini-cart-actions a {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 42px;
        text-decoration: none;
        border: 1px solid #111;
        font-size: 13px;
      }

      .mistika-mini-cart-actions a:last-child {
        background: #111;
        color: #fff;
      }

      @media (max-width: 480px) {
        #mistika-mini-cart-panel {
          top: 12px;
          right: 12px;
          width: calc(100vw - 24px);
        }
      }
    `;

    document.head.appendChild(style);
  }

  function formatMoney(valueInCents) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0
    }).format((valueInCents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function dispatchCartEvents(cart, addData) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart, addData: addData }
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, addData: addData }
      })
    );

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { cart: cart, product: addData }
      })
    );
  }
})();